import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderService } from '../../tools/header.service';
import { IxellAPIService, LoginData } from '../../tools/api.service';
import { Model } from '../../entities/model';
import { StorageService } from 'src/app/tools/storage.service';
import { LogInService } from '../../tools/login-service';

export enum StatsCBLogType {
    Gamme,
    Serie,
    Libelle
}

@Component({
    selector: 'globalColorbook',
    templateUrl: './globalColorbook.component.html',
    styleUrls: ['./globalColorbook.component.scss']
})

export class GlobalColorbookComponent implements OnInit, OnDestroy {

    model: Model;
    manufacturer: string;
    private backSub: any;

    private statsLogCBGammeSub: any;
    private statsLogCBSerieSub: any;
    private statsLogCBLibelleSub: any;

    canBackColorbookBalance: boolean = false;
    //private canBackSub: any;

    login: string;

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    constructor(private apiService: IxellAPIService, private headerService: HeaderService, private storage: StorageService, private router: Router, private route: ActivatedRoute) { }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    ngOnInit(): void {
        ///*----------------------------------------------------------------------------------------------------*/console.log("/*----------------------------------------------------------------------------------------------------*/");
        ///*----------------------------------------------------------------------------------------------------*/console.log("global : ngoninit");
        //this.headerService.changeTitle("Colorbook");
        //this.headerService.changeCanBack(true);

        this.login = this.route.snapshot.paramMap.get('login');
        if (!this.login) this.login = this.route.snapshot.queryParams['login'];
        if (this.login) {
            this.canBackColorbookBalance = true;
        }

        this.headerService.changeTitle("Colorbook");
        this.backSub = this.headerService.currentBack.subscribe(back => {
            if (back) {
                if (this.model != null) {
                    this.storage.remove("model");
                    this.model = null;
                    this.headerService.changeTitle("ColorBook");
                }
                else {
                    if (this.storage.get("serie") != null) {
                        this.storage.remove("serie");
                        this.headerService.changeRemoveSerie(true);
                    }
                    else {
                        if (this.storage.get("gamme") != null) {
                            this.storage.remove("gamme");
                            this.headerService.changeRemoveGamme(true);
                        }
                        else {

                            if (this.login) { }
                            else {
                                this.storage.remove("colorCode");
                                this.headerService.changeTitle("IxellWebLab");
                                this.headerService.changeCanBack(false);
                                this.headerService.changeLogo(null);
                                this.router.navigateByUrl("/home");
                            }

                        }
                    }
                }
                this.headerService.changeBack(false);
            }
        });


    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Attention : le bouton est propre à la colorwin
     */
    previousColorWin() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("global : previousColorWin");

        //if (this.router.url == "/colorwebtech" || this.router.url == "/colorbook")
        this.headerService.changeBack(true);
        window.history.back();

        //if (this.storage.get("model") != null) {
        //  this.storage.remove("model");
        //  this.model = null;
        //  this.headerService.changeTitle("ColorBook");
        //}
        //else {
        //  if (this.storage.get("serie") != null) {
        //    this.storage.remove("serie");
        //    this.headerService.changeRemoveSerie(true);
        //  }
        //  else { 
        //    if (this.storage.get("gamme") != null) {
        //      this.storage.remove("gamme");
        //      this.headerService.changeRemoveGamme(true);
        //    }
        //    else {

        //      if (this.login) { }
        //      else {
        //        this.storage.remove("colorCode");
        //        this.headerService.changeTitle("IxellWebLab");
        //        this.headerService.changeCanBack(false);
        //        this.headerService.changeLogo(null);
        //        this.router.navigateByUrl("/home");
        //      }

        //    }
        //  }
        //}
        //this.headerService.changeBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    previous() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("global : previous");
        if (this.router.url == "/colorwebtech" || this.router.url == "/colorbook")
            this.headerService.changeBack(true);
        else {
            if (this.router.url == "/panier")
                this.router.navigate(["/catalogue"]);
            else
                window.history.back();
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    ngOnDestroy(): void {
        if (this.backSub != null) this.backSub.unsubscribe();

        if (this.statsLogCBGammeSub != null) this.statsLogCBGammeSub.unsubscribe();
        if (this.statsLogCBSerieSub != null) this.statsLogCBSerieSub.unsubscribe();
        if (this.statsLogCBLibelleSub != null) this.statsLogCBLibelleSub.unsubscribe();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    selectModel(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("global : selectModel");
        this.model = event;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    changeManufacturer(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("global : changeManufacturer");
        this.manufacturer = event;
    }


    statsLog(event: any) {
        switch (event.type) {
            case StatsCBLogType.Gamme:
                {
                    this.statsLogCBGammeSub = this.apiService.statsLogCBGamme(event.value).subscribe(() => {
                        if (this.statsLogCBGammeSub != null) this.statsLogCBGammeSub.unsubscribe();
                    });
                    break;
                }
            case StatsCBLogType.Serie:
                {
                    this.statsLogCBSerieSub = this.apiService.statsLogCBSerie(event.value).subscribe(() => {
                        if (this.statsLogCBSerieSub != null) this.statsLogCBSerieSub.unsubscribe();
                    });
                    break;
                }
            case StatsCBLogType.Libelle:
                {
                    this.statsLogCBLibelleSub = this.apiService.statsLogCBLibelle(event.value).subscribe(() => {
                        if (this.statsLogCBLibelleSub != null) this.statsLogCBLibelleSub.unsubscribe();
                    });
                    break;
                }
            default:
                break;
        }
    }
}
